// src/ui/notifications/toast.jsx
import React, { useEffect, useState } from "react";

/** API simples: toast.push({ level: 'info'|'success'|'warning'|'error', title?: string, msg: string, duration?: number }) */
export const toast = {
  push(payload) {
    const detail = {
      id: crypto.randomUUID(),
      level: "info",
      duration: 4500,
      ...payload,
    };
    window.dispatchEvent(new CustomEvent("ll:toast", { detail }));
  },
};

export function ToastViewport() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    function onToast(e) {
      const t = e.detail;
      setToasts((prev) => [...prev, t]);

      // autodestruir após duração
      const timer = setTimeout(() => {
        setToasts((prev) => prev.filter((x) => x.id !== t.id));
      }, Math.max(1500, t.duration || 4500));

      // se remover manualmente antes, limpa o timer
      t._timer = timer;
    }

    window.addEventListener("ll:toast", onToast);
    return () => window.removeEventListener("ll:toast", onToast);
  }, []);

  const remove = (id) => {
    setToasts((prev) => {
      const t = prev.find((x) => x.id === id);
      if (t?._timer) clearTimeout(t._timer);
      return prev.filter((x) => x.id !== id);
    });
  };

  const colorBy = {
    info: "bg-blue-600",
    success: "bg-green-600",
    warning: "bg-amber-600",
    error: "bg-red-600",
  };

  return (
    <div className="fixed z-[1000] top-4 right-4 space-y-3 pointer-events-none">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`relative text-white rounded-lg shadow-lg px-4 py-3 w-80 pointer-events-auto ${colorBy[t.level] || colorBy.info}`}
        >
          {t.title && <div className="font-semibold">{t.title}</div>}
          <div className="text-sm opacity-95">{t.msg}</div>

          <button
            aria-label="Fechar"
            onClick={() => remove(t.id)}
            className="absolute top-1.5 right-2 text-white/90 hover:text-white"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
